import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const ControlsBlock = ({ children, hidden, disabled, style, className }) => {
	const blockCx = cx(styles.block, className, {
		[styles.hidden]: hidden,
		[styles.shown]: !hidden,
		[styles.disabled]: disabled
	});

	return (
		<div style={style} className={blockCx}>
			<div className={styles.blockInner}>{children}</div>
		</div>
	);
};

ControlsBlock.propTypes = {
	children: PropTypes.node.isRequired,
	hidden: PropTypes.bool,
	style: PropTypes.object,
	disabled: PropTypes.bool,
	className: PropTypes.string
};

ControlsBlock.defaultProps = {
	hidden: false,
	disabled: false
};

export default ControlsBlock;
